import styled, {css} from 'styled-components';
import {WBIcon} from '@wandb/ui';

const IconVariants = {
  small: css`
    font-size: 12px;
  `,
  medium: css`
    font-size: 14px;
  `,
  large: css`
    font-size: 16px;
  `,
};

export const Icon = styled(WBIcon)<{
  size: keyof typeof IconVariants;
  $pos: string;
  $opacity?: number;
}>`
  ${props => IconVariants[props.size]};
  margin: 4px 4px 4px 4px;
  ${props =>
    props.$pos === 'left' ? `margin-left: -4px;` : `margin-right: -4px;`}
  display: flex;
  align-items: center;
  opacity: ${props => props.$opacity};
`;
